(function () {
    $(document).ready(function () {
        //GET RECIPE ID
        var id = "";

        //CHECK FOR QUERY STRING
        var urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get('id') !== null) {
            id = urlParms.get('id');
        }
        else {
            var url = window.location.pathname.split("/");
            if (url.length === 4) {
                id = url[3];
            }
        }

        //DISPLAY THE SPECIFIED RECIPE
        if (id.length > 0) {
            getRecipe(id);
        }
        else {
            $("#recipeWrapper > .contain-width").html("<h1>Invalid Recipe</h1><h3>Sorry for the inconvenience, but this recipe does not exist.</h3><p><a class='page-back' href='/pages/recipes'>Back To Recipe List</a></p>");
        }
    });

    function displayRecipe(recipe) {
        if (typeof recipe === "undefined") {
            $("#recipeWrapper > .contain-width").html("<h1>Invalid Recipe</h1><h3>Sorry for the inconvenience, but this recipe does not exist.</h3><p><a class='page-back' href='/pages/recipes'>Back To Recipe List</a></p>");
        }
        else {
            let recipeHtml = "";
            recipeHtml += "<div class='row no-gutter recipe-details-wrapper'>";
            recipeHtml += "<div class='col-md-8 col-sm-12 recipe-details-container'>";
            recipeHtml += "<div class='recipe-details'>";
            recipeHtml += "<div class='recipe-details-header'>";
            recipeHtml += "<h1>" + recipe.title + "</h1>";
            recipeHtml += "<hr />";
            recipeHtml += "<div id='backPrintShareContainer' class='print-hide'>";
            recipeHtml += "<a class='page-back' href='/pages/recipes'><span class='fa fa-angle-left'></span>Back To Recipe List</a>";
            recipeHtml += "<div class='print-hide print-share'>";
            recipeHtml += "<div class='print'>";
            recipeHtml += "<a>Print</a>";
            recipeHtml += "</div>";
            recipeHtml += "<div class='share'>";
            recipeHtml += "<div class='share-header'>Share</div>";
            recipeHtml += "<ul class='share-list sub-nav'>";
            recipeHtml += "<li><a class='facebook' href='https://www.facebook.com/sharer.php?u=https://www.meyermarket.com/pages/recipe/" + recipe.url + "' target='_blank'><span class='fab fa-facebook-f' displayText='Facebook'></span></a></li>";
            recipeHtml += "<li><a class='twitter' href='https://twitter.com/intent/tweet?url=https://www.meyermarket.com/pages/recipe/" + recipe.url + "' target='_blank'><span class='fab fa-twitter' displayText='Tweet'></span></a></li>";

            if (typeof recipe.images[0] !== "undefined" && recipe.images.length > 0) {
                recipeHtml += "<li class='last'><a class='pinterest' href='https://pinterest.com/pin/create/bookmarklet/?url=https://www.meyermarket.com/pages/recipe/" + recipe.url + "&media=" + recipe.images[0].filePath + recipe.images[0].fileName + "' target='_blank'><span class='fab fa-pinterest-p' displayText='Pinterest'></span></a></li>";
            }

            recipeHtml += "</ul>";
            recipeHtml += "</div>";
            recipeHtml += "</div>";
            recipeHtml += "</div>";
            recipeHtml += "<hr class='print-hide' />";

            let detailImages = recipe.images.filter((image) => image.imageType === "Detail");

            //The carousel code has not been implemented, so just display the first detail image.
            recipeHtml += "<div class='detail-image-container print-hide'>";
            recipeHtml += `<img alt='${recipe.title} class='recipeMainImage' height='${detailImages[0].height}' src='${detailImages[0].filePath}${detailImages[0].fileName}' width='${detailImages[0].width}' />`;
            recipeHtml += "<div class='hidden print-yield'>";
            recipeHtml += "<p>" + recipe.yieldUnitDescription + ": " + recipe.yield + "</p>";
            recipeHtml += "<p>Prep Time: " + recipe.prepTime + " " + recipe.prepTimeMeasurementDescription + "</p>";
            recipeHtml += "<p>Cook Time: " + recipe.cookTime + " " + recipe.cookTimeMeasurementDescription + "</p>";
            recipeHtml += "<p>Total Time: " + recipe.totalCookTime + " " + recipe.totalCookTimeMeasurementDescription + "</p>";
            recipeHtml += "</div>";
            recipeHtml += "<div class='clear hidden'>&nbsp;</div>";
            recipeHtml += "</div>";

            //if (detailImages.length === 1) {
            //    recipeHtml += "<div class='detail-image-container print-hide'>";
            //    recipeHtml += `<img alt='${recipe.title} class='recipeMainImage' height='${detailImages[0].height}' src='${detailImages[0].filePath}${detailImages[0].fileName}' width='${detailImages[0].width}' />`;
            //    recipeHtml += "<div class='hidden print-yield'>";
            //    recipeHtml += "<p>" + recipe.yieldUnitDescription + ": " + recipe.yield + "</p>";
            //    recipeHtml += "<p>Prep Time: " + recipe.prepTime + " " + recipe.prepTimeMeasurementDescription + "</p>";
            //    recipeHtml += "<p>Cook Time: " + recipe.cookTime + " " + recipe.cookTimeMeasurementDescription + "</p>";
            //    recipeHtml += "<p>Total Time: " + recipe.totalCookTime + " " + recipe.totalCookTimeMeasurementDescription + "</p>";
            //    recipeHtml += "</div>";
            //    recipeHtml += "<div class='clear hidden'>&nbsp;</div>";
            //    recipeHtml += "</div>";
            //}
            //else {
            //    recipeHtml += "<div id='recipeDetailImages' class='carousel slide print-hide' data-ride='carousel'>";
            //    recipeHtml += "<ol class='carousel-indicators'>";

            //    for (let i = 0; i < detailImages.length; i++) {
            //        recipeHtml += "<li data-target='#recipeDetailImages' data-slide-to='" + i + "'" + (i === 0 ? " class=active" : "") + "></li>";
            //    }

            //    recipeHtml += "</ol>";
            //    recipeHtml += "<div class='carousel-inner'>";

            //    for (let i = 0; i < detailImages.length; i++) {
            //        recipeHtml += "<div class='carousel-item " + (i === 0 ? "active" : "") + "'>";
            //        recipeHtml += `<img alt='Recipe Image' class='detail-image' height='${detailImages[i].height}' src='${detailImages[i].filePath}${detailImages[i].fileName}' width='${detailImages[i].width}' />`;
            //        recipeHtml += "</div>";
            //    }

            //    recipeHtml += "</div>";
            //    recipeHtml += "<a class='carousel-control-prev' href='#recipeDetailImages' role='button' data-slide='prev'>";
            //    recipeHtml += "<span class='carousel-control-prev-icon' aria-hidden='true'></span>";
            //    recipeHtml += "<span class='sr-only'>Previous</span>";
            //    recipeHtml += "</a>";
            //    recipeHtml += "<a class='carousel-control-next' href='#recipeDetailImages' role='button' data-slide='next'>";
            //    recipeHtml += "<span class='carousel-control-next-icon' aria-hidden='true'></span>";
            //    recipeHtml += "<span class='sr-only'>Next</span>";
            //    recipeHtml += "</a>";
            //    recipeHtml += "</div>";
            //}

            recipeHtml += "</div>";
            recipeHtml += "<div class='recipe-ingredients row'>";
            recipeHtml += "<div class='col-md-6 col-sm-12 ingredient-list'>";
            recipeHtml += "<h3>Ingredients</h3>";
            recipeHtml += "<ul>";

            for (let i = 0; i < recipe.ingredients.length; i++) {
                recipeHtml += "<li>";
                recipeHtml += "<span class='ingredient-quantity'>" + (recipe.ingredients[i].quantity === 0 ? "" : toFraction(recipe.ingredients[i].quantity)) + "</span>";
                recipeHtml += " <span class='ingredient-unit'>" + (typeof recipe.ingredients[i].unitOfMeasurement !== undefined ? recipe.ingredients[i].unitOfMeasurement.toLowerCase() : "") + "</span>";
                recipeHtml += " <span class='ingredient-name'>" + productLink(recipe.ingredients[i].name) + "</span>";
                recipeHtml += " <span class='ingredient-note'>" + (typeof recipe.ingredients[i].note !== "undefined" && recipe.ingredients[i].note.length > 0 ? " (" + recipe.ingredients[i].note + ")" : "") + "</span>";
                recipeHtml += "</li>";
            }

            recipeHtml += "</ul>";
            recipeHtml += "</div>";
            recipeHtml += "<div class='col-md-6 col-sm-12 serving-yield'>";

            if (typeof recipe.yield !== "undefined" && recipe.yield !== null && recipe.yield > 0) {
                recipeHtml += "<div class='print-hide recipe-serving-yield'>";
                recipeHtml += "<h5>Yield</h5>";
                recipeHtml += "<div class='yield-calculator'>";
                recipeHtml += "<form class='ingredient-refresh-wrapper' id='ingredientRefreshWrapper'>";
                recipeHtml += "<label for='recipeYieldCount'>" + recipe.yieldUnitDescription + ":</label> ";
                recipeHtml += "<input class='recipe-yield-count' id='recipeYieldCount' maxlength='4' type='number' value='" + recipe.yield + "' />";
                recipeHtml += "<input class='ingredient-refresh _gt' data-action='Change Servings' data-category='Recipes' data-label='Recipes-Refresh Servings' id='ingredientRefresh' type='submit' value='Refresh' />";
                recipeHtml += "</form>";
                recipeHtml += "</div>";
                recipeHtml += "<ul>";
                recipeHtml += "<li>";
                recipeHtml += "Prep Time: " + recipe.prepTime + " " + recipe.prepTimeMeasurementDescription + "</li>";
                recipeHtml += "<li>Cook Time: " + recipe.cookTime + " " + recipe.cookTimeMeasurementDescription + "</li>";
                recipeHtml += "<li>Total Time: " + recipe.totalCookTime + " " + recipe.totalCookTimeMeasurementDescription + "</li>";
                recipeHtml += "</ul>";
                recipeHtml += "</div>";
            }

            recipeHtml += "</div>";
            recipeHtml += "</div>";
            recipeHtml += "<hr class='clear preparation-divider' />";
            recipeHtml += "<h3>Preparation</h3>";
            recipeHtml += "<div class='preparation-container'>" + recipe.preparation + "</div>";

            if (typeof recipe.nutritionList !== "undefined" && recipe.nutritionList !== null && recipe.nutritionList.length > 0) {
                recipeHtml += "<hr />";
                recipeHtml += "<h3 class='nutriational-analysis-per-serving'>Nutritional Analysis Per Serving</h3>";
                recipeHtml += "<ul class='nutrition-list'>";

                for (let i = 0; i < recipe.nutritionList.length; i++) {
                    recipeHtml += "<li>" + recipe.nutritionList[i].typeDescription + ": " + recipe.nutritionList[i].quantity + recipe.nutritionList[i].unitOfMeasurement.toLowerCase() + "</li>";
                }

                recipeHtml += "</ul>";
            }
            else if (typeof recipe.notes !== "undefined" && recipe.notes.length > 0) {
                recipeHtml += recipe.notes;
            }

            recipeHtml += "</div>";
            recipeHtml += "</div>";
            recipeHtml += "<div class='col-md-4 col-sm-12 suggested-and-button-container print-hide'>";
            recipeHtml += "<div class='suggested-recipes-container'>";
            recipeHtml += "<h3>Suggested Recipes</h3>";
            recipeHtml += "<div class='row' id='suggestedRecipesContainer'>";
            recipeHtml += "</div>";
            recipeHtml += "</div>";
            recipeHtml += "</div>";

            $("#recipeWrapper > .contain-width").append(recipeHtml);

            //Print recipe
            $(".print-share .print a").click(function () {
                window.print();
            });

            //Refresh the yield
            var $servingCountField = $('.recipe-yield-count');
            window.currentServingVal = $servingCountField.val();

            $("#ingredientRefreshWrapper").submit(function (event) {
                event.preventDefault();

                var newServingVal = $servingCountField.val();
                if (newServingVal === "" || newServingVal === 0) {
                    $servingCountField.addClass('field-error');
                    return;
                }

                $servingCountField.removeClass('field-error');
                if (window.currentServingVal !== newServingVal) {

                    var multiplier = newServingVal / window.currentServingVal;

                    $('.ingredient-quantity').each(function () {
                        var $this = $(this);
                        if ($this.text() !== "") {
                            var currentValue = $this.text();
                            var currentDecValue = new Fraction(currentValue).valueOf();
                            var newValue = currentDecValue * multiplier;
                            var newFraction = new Fraction(newValue);
                            $this.text(newFraction.toFraction(true));
                            $this.addClass('changed-value');
                            window.setTimeout(function () {
                                $this.removeClass('changed-value');
                            }, 2000);
                        }
                    });

                    window.currentServingVal = newServingVal;
                }
            });
        }
    }

    function displaySuggestedRecipes(recipes) {
        let suggestedRecipesHtml = "";

        for (let i = 0; i < recipes.length; i++) {
            suggestedRecipesHtml += "<div class='col-md-12 suggested-recipe click-first-link'>";
            suggestedRecipesHtml += `<a href='${recipes[i].url}')'>`;
            suggestedRecipesHtml += "<div class='img-wrap'>";
            suggestedRecipesHtml += "<div class='img-overlay'></div>";
            suggestedRecipesHtml += `<img src='${recipes[i].mainImageFilePath}${recipes[i].mainImageFileName}' alt='${recipes[i].title}' />`;
            suggestedRecipesHtml += "</div>";
            suggestedRecipesHtml += `<h4 class='text-center'>${recipes[i].title}</h4>`;
            suggestedRecipesHtml += "</a>";
            suggestedRecipesHtml += "</div>";
        }

        document.getElementById("suggestedRecipesContainer").innerHTML = suggestedRecipesHtml;
    }

    function getRecipe(id) {
        Utility.showLoadingModal();
        fetch(`https://api.meyernaturalfoods.com/api/v1/recipes/${id}`, {
            headers: {
                'Accept': 'application/json'
            },
            method: 'GET'
        }).then((response) => {
            return response.json();
        }).then((data) => {
            displayRecipe(data);
            getSuggestedRecipes(id);
        }).catch((error) => {
            //console.log(error);
            $("#recipeWrapper > .contain-width").html("<h1>Invalid Recipe</h1><h3>Sorry for the inconvenience, but an error (0x625) has occurred.  Refresh the page and try again.</h3><p><a class='page-back' href='/pages/recipes'>Back To Recipe List</a></p>");
        }).finally(() => {
            setTimeout(
                function () {
                    Utility.hideLoadingModal();
                }, 1000
            );
        });
    }

    function getSuggestedRecipes(recipeToExclude) {
        fetch(`https://api.meyernaturalfoods.com/api/v1/recipes/getsuggested?recipetoexclude${recipeToExclude}`, {
            headers: {
                'Accept': 'application/json'
            },
            method: 'GET'
        }).then((response) => {
            return response.json();
        }).then((data) => {
            displaySuggestedRecipes(data);
        }).catch((error) => {
            //console.log(error);
        }).finally(() => {
        });
    }

    function productLink(productName) {
        switch (productName.toLowerCase()) {
            case "laura's lean ground beef":
                return "<a href='/collections/lauras-lean'>" + productName + "</a>";

            case "laura's lean chicken breast":
            case "laura's lean chicken breasts":
                return "<a href='/products/lauras-lean-chicken-breast'>" + productName + "</a>";

            case "laura's 96% lean ground beef":
                return "<a href='/products/lauras-lean-96-lean-ground-beef'>" + productName + "</a>";

            case "laura's 92% lean ground beef":
                return "<a href='/products/lauras-lean-92-lean-ground-beef'>" + productName + "</a>";

            case "laura's 85% grass fed ground beef":
                return "<a href='/products/lauras-lean-85-grass-fed-ground-beef'>" + productName + "</a>";

            case "dakota organic ground beef":
                return "<a href='/collections/dakota-organic'>" + productName + "</a>";

            case "dakota organic 90/10 ground beef":
                return "<a href='/products/dakota-organic-90-10-ground-beef'>" + productName + "</a>";

            case "dakota organic 85/15 ground beef":
                return "<a href='/products/dakota-organic-85-15-ground-beef'>" + productName + "</a>";

            case "meyer natural angus":
                return "<a href='/collections/meyer-natural-angus'>" + productName + "</a>";

            case "meyer natural angus ribeye":
                return "<a href='/products/meyer-natural-angus-usda-prime-ribeye'>" + productName + "</a>";

            case "meyer natural angus new york strip":
                return "<a href='/products/meyer-natural-angus-usda-prime-new-york-strip'>" + productName + "</a>";

            case "meyer natural angus filet mignon":
                return "<a href='/products/meyer-natural-angus-usda-prime-filet-mignon'>" + productName + "</a>";

            case "meyer natural angus top sirloin":
            case "meyer natural angus top sirloin steak":
            case "meyer natural angus top sirloin steaks":
                return "<a href='/products/meyer-natural-angus-usda-prime-top-sirloin'>" + productName + "</a>";

            case "meyer heritage duroc pork":
                return "<a href='/collections/meyer-natural-pork'>" + productName + "</a>";

            case "meyer heritage duroc bacon":
                return "<a href='/products/applewood-smoked-uncured-duroc-pork-bacon'>" + productName + "</a>";

            default:
                return productName;
        }
    }

    function toFraction(value) {
        var fraction = new Fraction(value);
        return fraction.toFraction(true);
    }
}());